import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { Note, NoteCreate } from './workforce-disruption-placements-candidate-note-model';

@Injectable({
    providedIn: 'root'
})
export class WorkforceDisruptionPlacementsCandidateNoteService {
    private readonly _coreApiPath: string;
    private readonly _wfdApiPath: string;

    constructor(private readonly _httpClient: HttpClient, @Inject(APP_CONFIG) _settings: Settings) {
        this._coreApiPath = combine(_settings.coreAPIUrl, 'ayanova');
        this._wfdApiPath = combine(this._coreApiPath, 'workforce-disruption/contracts-placements');
    }

    getNotes(contractId: number): Observable<Note[]> {
        const path = `${this._wfdApiPath}/${contractId}/notes`;
        return this._httpClient.get<Note[]>(path);
    }

    addNote(note: NoteCreate, contractId: number): Observable<Note> {
        const path = `${this._wfdApiPath}/${contractId}/notes`;
        return this._httpClient.post<Note>(path, note);
    }
}
